<wbo-edit-page #editPage [title]="data.name">
    <fui-formation-group class="basic-group no-header">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name" [(ngModel)]="data.name">
                            </wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control
                                formControlName="discontinued"
                                [(ngModel)]="data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                    <fui-column>
                        <wbo-price-level-single-select-edit-control
                            formControlName="priceLevelId" [objectValue]="data.priceLevel"
                            [allowClearSelectionOption]="false"
                            [readonly]="priceLevelLocked"
                            [(ngModel)]="data.priceLevelId"></wbo-price-level-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-terminal-multi-select-edit-control formControlName="terminals"
                                                                [(ngModel)]="data.terminals"
                                                                [multiObjectValueType]="true">
                        </wbo-terminal-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group [title]="'wbo.price-level-schedule.edit.formation.schedule'">
        <wbo-pricing-schedule-edit></wbo-pricing-schedule-edit>
    </fui-formation-group>
</wbo-edit-page>
